import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TenantService } from '../tenant/tenant.service';

/**
 * Guard del módulo SUPER_ADMIN (multi-tenant).
 *
 * IMPORTANTE: esto es solo defensa en profundidad en el front. El backend ya
 * responde 404 para cualquier endpoint `/super-admin/*` fuera del tenant
 * maestro, así que la seguridad real vive ahí; este guard únicamente evita
 * exponer la navegación/UI a usuarios que de todos modos no podrían usarla.
 *
 * Exige DOS condiciones, si alguna falla redirige a `/dashboard`:
 *  1. El usuario autenticado tiene rol SUPER_ADMIN (idRole === 5).
 *  2. El contexto de tenant actual es el tenant maestro (o estamos en
 *     localhost, tratado como maestro para desarrollo).
 */
export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const tenant = inject(TenantService);
  const router = inject(Router);

  const esSuperAdmin = auth.getRoleId() === 5;
  const esTenantMaestro = tenant.esHostMaestro();

  return esSuperAdmin && esTenantMaestro ? true : router.createUrlTree(['/dashboard']);
};
